import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import CallAPI from '../../../../adminpanel/components/commonComponents/AxiosHelper';
import Form from '../../../../adminpanel/components/commonComponents/Form.v2';
import ModalComponent from '../../../../adminpanel/components/commonComponents/ModalComponent';
import { formatBytes } from "../../commonComponents/CommonHelper";
import Grid from '../../commonComponents/Grid';
import SFTPTypeConnect from '../loadData/SFTPTypeConnect';
import { ModalDetails, modalDropDownEvents, MappingEvent, RefreshEvent, modalOnChangeHandle } from "./ModalOptions";
import { Redirect, Link } from 'react-router-dom';

const GridParent = ({ renderData, authData, folderEvent, getInitialData, urlParams }) => {

    const [modalToView, setmodalToView] = useState({});
    const [dataToSend, setdataToSend] = useState({});
    const [selectedFiles, setSelectedFiles] = useState({});
    const [redirectPath, setRedirectPath] = useState(null)
    let visualLoop = {};
    let connectionNames = {};
    let moreOptions = [
        { "id": "appendData", "name": "Append Data", "icon": "database", "type": "function" },
        { "id": "overWrite", "name": "Overwrite", "icon": "database", "type": "function" },
        { "id": "makeDataset", "name": "Make as Dataset", "icon": "plus", "type": "function" },
        //{ "id": "setDictionary", "name": "Set Dictionary", "icon": "git-commit", "type": "function" },
        { "id": "updateSettings", "name": "Pipeline Settings", "icon": "edit-3", "type": "function" },
        { "id": "dataQuality", "name": "Data Quality", "icon": "file-plus", "type": "function" },
        { "id": "viewRawData", "name": "View Raw Data", "link": "/adminpanel/v2/view_raw_data/_replace_name_", "target": "_blank", "icon": "eye", "type": "link" },
        { "id": "delete", "name": "Delete", "icon": "trash", "type": "function" },
        { "id": "update", "name": "Update Settings", "icon": "edit", "type": "function" }
    ]

    const formDropdownEvents = (e) => {
        modalDropDownEvents(e, modalToView, setmodalToView, authData, dataToSend)
    }

    const formOnChangeHandle = (e) => {
        modalOnChangeHandle(e, modalToView, setmodalToView)
    }

    const handleOptions = (clickName, eventDetails) => {
        ModalDetails(clickName, eventDetails, renderData, setSelectedFiles, setmodalToView, setdataToSend, selectedFiles)
    }

    const handleDoubleClick = (folderDetails) => {
        setRedirectPath(`/adminpanel/v2/view_connection_data/${folderDetails.targetTableName.split('.')[0]}/${folderDetails.targetTableName.split('.')[1]}/${folderDetails.connectionId}`);
    }

    const handleFixEvent = (folderDetails) => {
        MappingEvent(folderDetails, setmodalToView, setdataToSend)
    }

    const modalSubmission = (event) => {
        let params = {
            siteId: authData.siteId
        }
        let target = event.target.name;
        let url = null;
        let postData = null;
        let responseType = null;
        let sampleModalData = { ...modalToView }
        let userID = authData.userId

        if (target === "appendData") {
            params.auth = "system";
            url = '/app/system/pullClientData_v1';

            if (modalToView.formData['connection_type'] && modalToView.formData['connection_type'] === "sftp") {
                dataToSend['pull_information'] = [{ ...modalToView.formData }];
            } else {
                $(`#${target}Form`).serializeArray().map((innerData) => {
                    if (innerData.name === 'filter' && innerData.value !== '') {
                        dataToSend['pull_information'][0][innerData.name] = { 'whereCondition': innerData.value }
                    } else dataToSend['pull_information'][0][innerData.name] = innerData.value;
                })
            }
            dataToSend['pull_information'][0]['min_split'] === '' ? delete dataToSend['pull_information'][0]['min_split'] : null
            dataToSend['pull_information'][0]['data_split'] === '' ? delete dataToSend['pull_information'][0]['data_split'] : null
            dataToSend['pull_information'][0]['filter'] === '' ? delete dataToSend['pull_information'][0]['filter'] : null
            dataToSend['api_request'] = true
            dataToSend['user'] = userID
            dataToSend['userId'] = userID
            postData = dataToSend;
        } else if (target === "updateSettings") {
            url = '/app/update_table_info';
            $(`#${target}Form`).serializeArray().map((innerData) => {
                if (innerData.value) {
                    if (innerData.name === "customFilePattern") {
                        dataToSend['update_information'][0]['pipeline_frequency']['filePattern'] = innerData.value;
                    } else if (innerData.name === 'status') {
                        dataToSend['update_information'][0]['pipeline_frequency'][innerData.name] = JSON.parse(innerData.value);
                    } else dataToSend['update_information'][0]['pipeline_frequency'][innerData.name] = innerData.value;
                }
            })
            dataToSend['update_information'][0]['masterTable'] ? dataToSend['update_information'][0]['pipeline_frequency']['deleteType'] = "entire_data" : null
            delete dataToSend['update_information'][0]['masterTable']
            postData = dataToSend['update_information'];
            postData['user'] = userID;
            postData['userId'] = userID;
        } else if (target === "makeDataset") {
            params.email = authData.username;
            url = '/app/make_dataset_v2';
            let tempObj = {}
            $(`#${target}Form`).serializeArray().map((innerData) => {
                tempObj[innerData.name] = innerData.value;
            })
            dataToSend['dataset_name'] = tempObj.datasetName;
            dataToSend['dateColumn'] = tempObj.dateColumn;
            dataToSend['api_request'] = true;
            dataToSend['user'] = userID;
            dataToSend['userId'] = userID;
            postData = dataToSend;
        } else if (target === "overWrite") {
            let masterTable = dataToSend['pull_information'][0]['masterTable']
            params.auth = "system";
            url = '/app/system/pullClientData_v1';
            if (dataToSend['pull_information'][0]['connection_type'] === "sftp") {
                delete dataToSend['pull_information'][0]['clientDBName']
                delete dataToSend['pull_information'][0]['clientTableName']
                delete dataToSend['pull_information'][0]['dateColumn']
                delete dataToSend['pull_information'][0]['endDate']
                delete dataToSend['pull_information'][0]['startDate']
            }
            $(`#${target}Form`).serializeArray().map((innerData) => {
                if (innerData.value && innerData !== null) {
                    if (innerData.name === 'filter') {
                        dataToSend['pull_information'][0][innerData.name] = { 'whereCondition': innerData.value }
                    } else if (innerData.name === 'truncateData') {
                        dataToSend['pull_information'][0][innerData.name] = JSON.parse(innerData.value);
                    } else dataToSend['pull_information'][0][innerData.name] = innerData.value;
                }
            })
            if (dataToSend['pull_information'][0]['overwriteType'] === "full" || masterTable) {
                dataToSend['pull_information'][0]['overwriteCondition'] = { "entire": true }
            } else if (dataToSend['pull_information'][0]['overwriteType'] === "file") {
                dataToSend['pull_information'][0]['overwriteCondition'] = { "fileName": [dataToSend['pull_information'][0]['fileName']] }
            }
            masterTable ? dataToSend['pull_information'][0]['entireData'] = true : null
            delete dataToSend['pull_information'][0]['fileName']
            delete dataToSend['pull_information'][0]['overwriteType']
            delete dataToSend['pull_information'][0]['masterTable']
            dataToSend['api_request'] = true
            dataToSend['user'] = userID
            dataToSend['userId'] = userID
            postData = dataToSend;
        } else if (target === "mapping") {
            params.auth = "system";
            url = '/app/system/pullClientData_v1';
            let db_missing = modalToView.errorMessage.db_missing
            let file_missing = modalToView.errorMessage.file_missing
            if (db_missing) {
                db_missing.map(function (innerData) {
                    let selectedValue = document.getElementById(`${innerData}_form_data`).value
                    if (selectedValue) {
                        if (selectedValue == "addColumn") {
                            dataToSend['pull_information'][0]['newColumns'].push(innerData);
                            dataToSend['pull_information'][0]['mapping_sent'][innerData] = innerData
                        } else if (selectedValue == "ignoreColumn") {
                            dataToSend['pull_information'][0]['ignoreColumns']["file_columns"].push(innerData);
                        } else {
                            dataToSend['pull_information'][0]['mapping_sent'][innerData] = selectedValue
                            file_missing = file_missing.filter(item => item !== selectedValue)
                        }
                    }
                })
            }
            if (file_missing) {
                file_missing.map(function (innerData) {
                    let selectedValue = document.getElementById(`${innerData}_form_data`).value
                    if (selectedValue && selectedValue == "ignoreColumn") {
                        dataToSend['pull_information'][0]['ignoreColumns']["db_columns"].push(innerData);
                    }
                })
            }
            dataToSend['pull_information'][0]['newColumns'].length === 0 ? delete dataToSend['pull_information'][0]['newColumns'] : null
            Object.keys(dataToSend['pull_information'][0]['mapping_sent']).length === 0 ? delete dataToSend['pull_information'][0]['mapping_sent'] : null
            dataToSend['pull_information'][0]['connectionId'] = modalToView.folderDetails.connectionId
            dataToSend['pull_information'][0]['connection_type'] = "manual"
            dataToSend['request_id'] = JSON.parse(modalToView.folderDetails.information).rm_backend_process_id;
            dataToSend['api_request'] = true;
            dataToSend['rm_backend_process'] = 1;
            dataToSend['user'] = userID;
            dataToSend['userId'] = userID;
        } else if (target === "dataQuality") {
            params.auth = "system";
            params.type = "pdf"
            url = '/app/system/fetchDataQuality'
            dataToSend['pull_information'][0]['connectionId'] ? delete dataToSend['pull_information'][0]['connectionId'] : null
            $(`#${target}Form`).serializeArray().map((innerData) => {
                if (innerData.value === "currentFile") {
                    delete dataToSend['pull_information'][0]['compare']
                } else if (innerData.value === "compareFile") {
                    delete dataToSend['pull_information'][0]['where']
                } else if (innerData.name === "compare_type") {
                    dataToSend['pull_information'][0]['compare'][innerData.name] = JSON.parse(innerData.value)
                } else if (innerData.name === "fileName") {
                    dataToSend['pull_information'][0]['compare']['rm_file_name'].push(innerData.value)
                } else if (innerData.name === "difference") {
                    params['force'] = true
                    params[innerData.name] = innerData.value
                }
            })
            postData = dataToSend['pull_information'][0]
            postData['user'] = userID;
            postData['userId'] = userID;
        } else if (target === "delete") {
            if (dataToSend['pull_information'][0].information === "folderDeletion") {
                url = '/app/delete_entire_data';
                postData = {
                    "id": dataToSend['pull_information'][0].id,
                    'userId': userID
                }
            } else {
                params.auth = "system";
                url = '/app/system/pullClientData_v1';
                dataToSend['api_request'] = true
                dataToSend['user'] = userID
                dataToSend['userId'] = userID
                postData = dataToSend;
            }
        } else if (target === "update") {
            url = '/app/update_table_info'
            $(`#${target}Form`).serializeArray().map((innerData) => {
                dataToSend['update_information'][0][innerData.name] = innerData.value;
                dataToSend['update_information'][0]['rockmetric_update_columns'].push(innerData.name);
            })
            postData = dataToSend['update_information'];
            postData['user'] = userID;
            postData['userId'] = userID;
        }

        let checkValidity = true
        if (target === 'makeDataset') {
            checkValidity = checkValidity ? (checkSpecialChars(postData.dataset_name) ? false : true) : false
        } else if (target === "update") {
            checkValidity = checkValidity ? (checkSpecialChars(postData[0].virtualTableName) ? false : true) : false
        }
        if (checkValidity === false) {
            alert("Please enter valid inputs!");
        } else {
            let fileType = 0;
            if (dataToSend['pull_information'] && dataToSend['pull_information'][0]['connection_type'] == "manual") {
                postData = new FormData();
                Object.keys(dataToSend['pull_information'][0]).map(function (innerData) {
                    let dataToAdd = typeof (dataToSend['pull_information'][0][innerData]) == "object" ? JSON.stringify(dataToSend['pull_information'][0][innerData]) : dataToSend['pull_information'][0][innerData]
                    postData.append(innerData, dataToAdd)
                })
                if (jQuery('#createFile') && jQuery('#createFile')[0]) {
                    let file = jQuery('#createFile')[0].files[0];
                    postData.append('uploadedfile', file);
                    fileType = 1
                }
                if (dataToSend['request_id']) {
                    postData.append('request_id', dataToSend['request_id']);
                    postData.append('rm_backend_process', true);
                }
                let encodedUserId = encodePassword(userID)
                postData.append('api_request', true);
                postData.append('user', encodedUserId);
                postData.append('userId', encodedUserId);
            } else if (dataToSend['pull_information'] && dataToSend['pull_information'][0]['connection_type'] == "sftp") {
                Object.keys(selectedFiles["selection"]).forEach((singleObj, index) => {
                    if (index > 0) {
                        dataToSend['pull_information'].push({ ...modalToView.formData });
                    }
                    dataToSend['pull_information'][index]['filePath'] = `${selectedFiles["selection"][singleObj].path}${selectedFiles["selection"][singleObj].filename}`
                })
                dataToSend['user'] = userID
                dataToSend['userId'] = userID
                postData = dataToSend;
            }

            sampleModalData.modal['isLoading'] = true
            sampleModalData.modal['formKey'] = `${sampleModalData.clickName}Form_${Math.floor(Math.random() * 10)}`;
            setmodalToView(sampleModalData);

            CallAPI('post', url, postData, params, fileType, function (response) {
                let urlset = false
                if (response.status === true) {
                    if (target === "makeDataset" || target === "dataQuality" || target === "appendData" || target === "overWrite") {
                        if (target === "makeDataset" || target === "dataQuality") {
                            alert(response.information);
                        } else if (response.information[0].status) {
                            alert(response['information'][0].information);
                        } else if (response.information[0].status === false) {
                            alert(response['information'][0].error_message);
                        }
                        window.open("/adminpanel/v2/apirequest/admin")
                    } else {
                        let tempInfoArr = response.information;
                        if (tempInfoArr[0].status === false) {
                            alert(tempInfoArr[0].error_message);
                        } else if (dataToSend['pull_information'] && dataToSend['pull_information'][0].information === "folderDeletion") {
                            alert(tempInfoArr);
                            getInitialData();
                        } else {
                            alert(tempInfoArr[0].information);
                            urlset = true
                            if (target !== "updateSettings" || target !== "update")
                                getInitialData();
                        }
                    }
                }
                jQuery(`#${target}Modal`).modal('toggle');
                jQuery(".modal-backdrop").remove();
                if (!urlset) {
                    sampleModalData.modal['isLoading'] = false
                    sampleModalData.modal['formKey'] = `${sampleModalData.clickName}Form_${Math.floor(Math.random() * 10)}`;
                    setmodalToView(sampleModalData);
                }
            }, authData, responseType);
            event.preventDefault();
        }
    }

    const refreshUnmappedDb = (e) => {
        RefreshEvent(e, modalToView, setmodalToView)
        e.preventDefault();
    }

    let displayModal = null
    if (modalToView.modal) {
        let filterForm = null;
        if (modalToView.type == "mapping") {
            filterForm = Object.keys(modalToView.formData).map(function (formKey) {
                return (
                    <>
                        <div className="divider-text">{modalToView.formData[formKey].label}
                            {formKey == "dbMapping" ?
                                <button type="button" className="btn btn-xs btn-uppercase btn-white mg-l-10" id="refresh" onClick={refreshUnmappedDb}>Refresh</button>
                                : null}
                        </div>
                        <Form
                            label_array={modalToView.formData[formKey].body}
                            formWidth={{ label: "col-md-4", "field": "col-md-8" }}
                        />
                    </>
                )
            })
        } else {
            filterForm = modalToView.formData && Object.keys(modalToView.formData).length > 0 && modalToView.formData['connection_type'] != "sftp"
                ? <Form
                    label_array={modalToView.formData}
                    handle_form_drop_down={["updateSettings", "overWrite", "dataQuality", 'appendData'].indexOf(modalToView.type) > -1 ? formDropdownEvents : null}
                    handleForm={["updateSettings", "overWrite", "dataQualityFile", 'appendData'].indexOf(modalToView.type) > -1 ? formOnChangeHandle : null} />
                : modalToView.formData && Object.keys(modalToView.formData).length > 0 && modalToView.formData['connection_type'] === "sftp" && dataToSend['pull_information'][0]['action'] === "append"
                    ? <SFTPTypeConnect authData={authData} initialData={modalToView.formData} nextBtnStatus={false} setSelectedFiles={setSelectedFiles} entireData={selectedFiles} />
                    : modalToView.formData && Object.keys(modalToView.formData).length > 0 && dataToSend['pull_information'][0]['connection_type'] === "sftp" && dataToSend['pull_information'][0]['action'] === "overwrite"
                        ? <>
                            <div className="mg-l-15 mg-r-15">
                                <Form
                                    label_array={modalToView.formData}
                                    handle_form_drop_down={["updateSettings", "overWrite"].indexOf(modalToView.type) > -1 ? formDropdownEvents : null}
                                    handleForm={["updateSettings", "overWrite"].indexOf(modalToView.type) > -1 ? formDropdownEvents : null}
                                    formWidth={{ label: "col-md-4", "field": "col-md-4" }}
                                />
                            </div>
                            <SFTPTypeConnect authData={authData} initialData={modalToView.formData} nextBtnStatus={false} setSelectedFiles={setSelectedFiles} entireData={selectedFiles} />
                        </>
                        : null
        }
        modalToView.modal['body'] = filterForm;
        if (modalToView.modal['id'] !== "updateSettingsModal") {
            modalToView.modal['formKey'] = `${modalToView.type}Form_${Math.floor(Math.random() * 10)}`;
        }
        modalToView.modal['size'] = Object.keys(modalToView.formData).indexOf('connection_type') !== -1
            ? modalToView.formData['connection_type'] === "sftp" || (dataToSend['pull_information'] && dataToSend['pull_information'][0]['connection_type'] === "sftp" && dataToSend['pull_information'][0]['action'] === "overwrite")
                ? "modal-xl"
                : null
            : null;
        displayModal = modalToView.modal && Object.keys(modalToView.modal).length > 0 ? <ModalComponent modalConfig={modalToView.modal} formSubmit={modalSubmission} /> : null;
    }

    renderData.map((singleElement) => {
        let loopKey = singleElement.targetTableName ? singleElement.connectionId : singleElement.data_summary
        if (connectionNames[loopKey] == undefined) {
            connectionNames[loopKey] = {
                connectionName: singleElement.targetTableName ? singleElement.connection_name : (singleElement.data_summary == '1' ? "Success" : singleElement.data_summary == '5' ? "Delete" : singleElement.data_summary == '0' ? "Error" : singleElement.data_summary == '4' ? "Overwrite" : "Dead Case"),
                connectionType: singleElement.targetTableName ? singleElement.connection_type : (singleElement.data_summary == '1' ? "Success" : singleElement.data_summary == '5' ? "Deleted Files" : singleElement.data_summary == '0' ? "Action Required" : singleElement.data_summary == '4' ? "Overwrite" : "Dead Case"),
            }
            visualLoop[loopKey] = [];
        }

        let sizeInfo = null;
        let description = null;
        let migrated = null;
        if (singleElement.information && singleElement.targetTable === undefined) {
            sizeInfo = formatBytes(JSON.parse(singleElement.information).fileSize);
            description = singleElement.information ? JSON.parse(singleElement.information).fileCount <= 1 ? `${JSON.parse(singleElement.information).fileCount} File,` : `${JSON.parse(singleElement.information).fileCount} Files,` : null
            migrated = JSON.parse(singleElement.information).migrated && JSON.parse(singleElement.information).migrated === 1 ? `Migrated` : null;
        } else {
            sizeInfo = singleElement.fileSize && singleElement.fileSize != "null" ? formatBytes(singleElement.fileSize) : "Not Exist";
            description = singleElement.rowCount ? `Row Count: ${singleElement.rowCount}` : null;
        }

        let title = singleElement.virtualTableName ? singleElement.virtualTableName : singleElement.targetTableName ? singleElement.targetTableName : singleElement.fileName

        title = title && title != "null" ? title :
            (singleElement.targetTable ? `${singleElement.targetTable.split('.')[1]}_${JSON.parse(singleElement.request_condition).startDate}_${JSON.parse(singleElement.request_condition).endDate}` : null)

        //for removing pipeline settings option in manual connection type
        var newMoreOptions = [...moreOptions]
        newMoreOptions.splice(3, 1)

        var ellipsisDropdownOptions = singleElement.type && (singleElement.type === 'Master' || singleElement.type === 'master')
            ? moreOptions.slice(1, 8)
            : singleElement.targetTableName && singleElement.connection_type == "sftp"
                ? moreOptions.slice(0, 8)
                : singleElement.targetTableName && singleElement.connection_type == "manual"
                    ? newMoreOptions
                    : singleElement.targetTableName && singleElement.connection_type !== "sftp" && singleElement.connection_type !== "manual"
                        ? moreOptions.slice(0, 8)
                        : singleElement.data_summary == 1 || singleElement.data_summary == 4
                            ? moreOptions.slice(4, 7)
                            : moreOptions.slice(6)

        visualLoop[loopKey].push(
            <Grid
                id={singleElement.targetTableName ? singleElement.targetTableName : singleElement.fileName}
                urlToReplace={singleElement.targetTableName ? singleElement.targetTableName.replace('.', "/") : `${singleElement.targetTable.replace('.', "/")}/${singleElement.fileName.replace('.csv', "")}`}
                title={title}
                icon={singleElement.targetTableName ? 'folder' : 'file-text'}
                lastTime={singleElement.lastPulledDate ? singleElement.lastPulledDate : singleElement.date}
                description={description}
                additionalDescription={sizeInfo ? `${sizeInfo} Size` : null}
                migrationInformation={migrated}
                moreOptions={ellipsisDropdownOptions}
                eventMore={handleOptions}
                eventDetails={{
                    tableName: singleElement.targetTableName,
                    connectionId: singleElement.connectionId,
                    virtualTableName: singleElement.virtualTableName,
                    connection_type: singleElement.connection_type && singleElement.connection_type !== null ? singleElement.connection_type.toLowerCase() : null,
                    fileInfo: singleElement ? singleElement : null
                }}
                folderEvent={singleElement.targetTableName ? folderEvent : null}
                folderDetails={singleElement}
                doubleClickHandle={singleElement.targetTableName ? handleDoubleClick : null}
                status={singleElement.targetTableName ? 'text-primary' : singleElement.data_summary == 1 ? 'text-success' : singleElement.data_summary == 5 ? 'text-muted' : singleElement.data_summary == 4 ? 'text-info' : 'text-danger'}
                dataSummary={singleElement.data_summary}
                popoverDetails={{
                    title: ",",
                    message: "kjsnkjs"
                }}
                mappingEvent={singleElement.fileName ? handleFixEvent : null}
            />
        );
    });

    if (redirectPath) {
        return <Redirect to={redirectPath} />
    }
    return <>
        {Object.keys(urlParams).length > 0 ? <label className="d-block tx-medium tx-10 tx-uppercase tx-sans tx-spacing-1 tx-color-03 mg-t-15 mg-b-15">
            <Link to="/adminpanel/v2/view_connection_data">Go Back</Link>
        </label> : null}
        {
            Object.keys(connectionNames).map(function (connectionIds) {
                return (
                    <>
                        <label className="d-block tx-medium tx-10 tx-uppercase tx-sans tx-spacing-1 tx-color-03 mg-t-15 mg-b-15" key={`individualLabel_${connectionIds}`}>
                            {`${connectionNames[connectionIds].connectionName} (${connectionNames[connectionIds].connectionType})`}
                        </label>
                        <div className="row row-xs" key={`individualRow_${connectionIds}`}>
                            {visualLoop[connectionIds]}
                        </div>
                    </>
                )
            })
        }
        {displayModal}
    </>
}

function mapStateToProps(state) {
    return { authData: { ...state.dataSet.authData, ...{ "toolId": state.dataSet.dataSet.toolId } } };
}

export default connect(mapStateToProps, null)(GridParent);